import React from 'react';
import { Button } from 'react-bootstrap';

// Skeleton loader component for the weekly plan
export const WeeklyPlanSkeleton = () => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const meals = ['Breakfast', 'Lunch', 'Dinner', 'Snack', 'Appetizer', 'Dessert', 'Other'];
  
  return (
    <div className="row weekly-plan-display skeleton-container">
      {days.map((day) => (
        <div key={day} className="col-lg-12 col-xl day-column">
          <div className="day-card skeleton-day-card">
            <div className="day-header">
              <h3 className="skeleton-text skeleton-day-title"></h3>
              <div className="day-totals skeleton-text skeleton-totals"></div>
            </div>
            
            {meals.map((meal) => (
              <div key={`${day}-${meal}`} className="meal-section skeleton-meal-section">
                <h4 className="meal-header skeleton-text skeleton-meal-header"></h4>
                
                {/* Show 1-2 skeleton recipe cards */}
                {[1, 2].slice(0, Math.random() > 0.5 ? 2 : 1).map((index) => (
                  <div key={index} className="recipe-card skeleton-recipe-card">
                    <div className="recipe-info">
                      <div className="skeleton-text skeleton-recipe-name"></div>
                      <div className="skeleton-text skeleton-recipe-servings"></div>
                    </div>
                    <div className="recipe-actions">
                      <button className="btn btn-sm skeleton-btn" disabled></button>
                      <button className="btn btn-sm skeleton-btn" disabled></button>
                      <button className="btn btn-sm skeleton-btn" disabled></button>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

// Inline loading spinner component
export const InlineSpinner = ({ size = 'sm', className = '' }) => {
  return (
    <span className={`spinner-border spinner-border-${size} ${className}`} role="status">
      <span className="visually-hidden">Loading...</span>
    </span>
  );
};

// Loading button component
export const LoadingButton = ({ children, isLoading, loadingText = 'Loading...', ...props }) => {
  return (
    <Button {...props} disabled={isLoading || props.disabled}>
      {isLoading ? (
        <>
          <InlineSpinner size="sm" className="me-2" />
          {loadingText}
        </>
      ) : (
        children
      )}
    </Button>
  );
};